export default __webpack_public_path__ + "KaTeX_Fraktur-Regular.0d90113d64d307cfb9e44a81546e7608.woff";